"use client";

import { useState } from "react";

type Row = {
  us: string;
  mm?: string;
  fra?: string;
  uk?: string;
  jpn?: string;
};

const ROWS: Row[] = [
  { us: "4",    mm: "14.9", fra: "47",   uk: "H",   jpn: "7"  },
  { us: "4.5",  mm: "15.3", fra: "48",   uk: "I",   jpn: "8"  },
  { us: "5",    mm: "15.7", fra: "49",   uk: "J",   jpn: "9"  },
  { us: "5.5",  mm: "16.1", fra: "51",   uk: "K",   jpn: "10" },
  { us: "6",    mm: "16.5", fra: "52",   uk: "M",   jpn: "11" },
  { us: "6.5",  mm: "16.9", fra: "53",   uk: "N",   jpn: "13" },
  { us: "7",    mm: "17.3", fra: "54.5", uk: "O",   jpn: "14" },
  { us: "7.5",  mm: "17.7", fra: "56",   uk: "P",   jpn: "16" },
  { us: "8",    mm: "18.1", fra: "57",   uk: "Q",   jpn: "17" },
  { us: "8.5",  mm: "18.5", fra: "58",   uk: "R",   jpn: "18" },
  { us: "9",    mm: "18.9", fra: "59",   uk: "S",   jpn: "20" },
  { us: "9.5",  mm: "19.4", fra: "61",   uk: "T",   jpn: "21" },
  { us: "10",   mm: "19.8", fra: "62",   uk: "U",   jpn: "22" },
  { us: "10.5", mm: "20.2", fra: "63",   uk: "V",   jpn: "24" },
  { us: "11",   mm: "20.6", fra: "65",   uk: "W",   jpn: "25" },
  { us: "11.5", mm: "21.0", fra: "66",   uk: "X",   jpn: "26" },
  { us: "12",   mm: "21.4", fra: "67",   uk: "Y",   jpn: "28" },
  { us: "12.5", mm: "21.7", fra: "68.5", uk: "Z",   jpn: "29" },
  { us: "13",   mm: "22.1", fra: "69.5", uk: "Z+1", jpn: "30" },
];

export function RingSizeChart() {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full max-w-full overflow-hidden border-t border-slate-200">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between px-0 py-4 text-sm font-medium text-slate-900 transition hover:text-slate-600"
        aria-expanded={open}
      >
        <span>Size Chart</span>
        <span className="text-lg leading-none text-slate-500">{open ? "−" : "+"}</span>
      </button>

      {open && (
        <div className="pb-4">
          <table className="w-full border-collapse text-center text-sm text-slate-700">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="px-2 py-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">US Size</th>
                <th className="px-2 py-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">Internal (mm)</th>
                <th className="px-2 py-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">FRA</th>
                <th className="px-2 py-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">UK / AUS</th>
                <th className="px-2 py-2 text-[10px] font-semibold uppercase tracking-[0.08em] text-slate-500">JPN / SGP</th>
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.us} className="border-b border-slate-100 last:border-0">
                  <td className="py-2 px-2">{row.us}</td>
                  <td className="py-2 px-2">{row.mm ?? ""}</td>
                  <td className="py-2 px-2">{row.fra ?? ""}</td>
                  <td className="py-2 px-2">{row.uk ?? ""}</td>
                  <td className="py-2 px-2">{row.jpn ?? ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
